export default {
  badge: 'Skilt',
  open: 'Åpne',
  close: 'Lukk',
  dismiss: 'Avvis',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Avbryt',
  },
  dataIterator: {
    noResultsText: 'Fant ingen matchende elementer.',
    loadingText: 'Laster...',
  },
  dataTable: {
    itemsPerPageText: 'Rader per side:',
    ariaLabel: {
      sortDescending: 'Sortert synkende.',
      sortAscending: 'Sortert stigende.',
      sortNone: 'Ikke sortert.',
      activateNone: 'Aktiver for å fjerne sortering.',
      activateDescending: 'Aktiver for å sortere synkende.',
      activateAscending: 'Aktiver for å sortere stigende.',
    },
    sortBy: 'Sorter etter',
  },
  dataFooter: {
    itemsPerPageText: 'Elementer per side:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Neste side',
    prevPage: 'Forrige side',
    firstPage: 'Første side',
    lastPage: 'Siste side',
    pageText: '{0}-{1} av {2}',
  },
  dateRangeInput: {
    divider: 'til',
  },
  datePicker: {
    itemsSelected: '{0} valgt',
    range: {
      title: 'Velg datoer',
      header: 'Velg datoer',
    },
    title: 'Velg dato',
    header: 'Velg dato',
    input: {
      placeholder: 'Fyll inn dato',
    },
    ariaLabel: {
      previousMonth: 'Forrige måned',
      nextMonth: 'Neste måned',
      selectYear: 'Velg år',
      previousYear: 'Forrige år',
      nextYear: 'Neste år',
      selectMonth: 'Velg måned',
      selectDate: '{0}',
      currentDate: 'I dag, {0}',
    },
  },
  noDataText: 'Ingen data er tilgjengelig',
  carousel: {
    prev: 'Forrige bilde',
    next: 'Neste bilde',
    ariaLabel: {
      delimiter: 'Karusellbilde {0} av {1}',
    },
  },
  calendar: {
    moreEvents: '{0} flere',
    today: 'I dag',
  },
  input: {
    clear: 'Fjern {0}',
    prependAction: '{0} foranstilt handling',
    appendAction: '{0} etterstilt handling',
    otp: 'Vennligst skriv inn OTP-tegn {0}',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1} totalt)',
  },
  fileUpload: {
    title: 'Dra og slipp filer her',
    divider: 'eller',
    browse: 'Bla gjennom filer',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Velg tid',
    hour: 'Time',
    minute: 'Minutter',
    second: 'Sekunder',
    notAllowed: 'Verdien er ikke tillatt',
  },
  pagination: {
    ariaLabel: {
      root: 'Paginasjonsnavigasjon',
      next: 'Neste side',
      previous: 'Forrige side',
      page: 'Gå til side {0}',
      currentPage: 'Gjeldende side, side {0}',
      first: 'Første side',
      last: 'Siste side',
    },
  },
  stepper: {
    next: 'Neste',
    prev: 'Forrige',
  },
  rating: {
    ariaLabel: {
      item: 'Anmeldelse {0} av {1}',
    },
  },
  loading: 'Laster...',
  infiniteScroll: {
    loadMore: 'Last flere',
    empty: 'Det var alt',
  },
  rules: {
    required: 'Dette feltet er påkrevd',
    email: 'Vennligst skriv inn en gyldig e-postadresse',
    number: 'Dette feltet kan kun inneholde tall',
    integer: 'Dette feltet kan kun inneholde heltall',
    capital: 'Dette feltet kan kun inneholde store bokstaver',
    maxLength: 'Du må skrive inn maksimalt {0} tegn',
    minLength: 'Du må skrive inn minimum {0} tegn',
    strictLength: 'Lengden på det angitte feltet er ugyldig',
    exclude: 'Tegnet {0} er ikke tillatt',
    notEmpty: 'Vennligst velg minst én verdi',
    pattern: 'Ugyldig format',
  },
  command: {
    search: 'Skriv en kommando eller søk...',
  },
  hotkey: {
    then: 'deretter',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Pil opp',
    downArrow: 'Pil ned',
    leftArrow: 'Pil venstre',
    rightArrow: 'Pil høyre',
    backspace: 'Slett',
    space: 'Mellomrom',
    plus: 'pluss',
    shortcut: 'Tastatursnarveier: {0}',
    or: 'eller',
  },
  video: {
    play: 'Spill av',
    pause: 'Pause',
    seek: 'Søk',
    volume: 'Volum',
    showVolume: 'Vis volumkontroll',
    mute: ' Demp',
    unmute: 'Slå på lyd',
    enterFullscreen: 'Fullskjerm',
    exitFullscreen: 'Avslutt fullskjerm',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Velg farge fra skjermen',
      hueSlider: 'Fargetone',
      alphaSlider: 'Alfa',
      redInput: 'Rød',
      greenInput: 'Grønn',
      blueInput: 'Blå',
      alphaInput: 'Alfa',
      hueInput: 'Fargetone',
      saturationInput: 'Metning',
      lightnessInput: 'Lyshet',
      hexInput: 'HEX-verdi',
      hexaInput: 'HEX med alfa-verdi',
      changeFormat: 'Endre fargeformat',
    },
  },
}
